import { IMenuHref } from '@websolutespa/bom-core';
import { OpenGraphImage } from '@websolutespa/bom-mixer-models';

export type IPimImage = {
  token: string;
  name: string;
  width?: number;
  height?: number;
};

export type IPimFile = {
  token: string;
  name: string;
};

export const pimImageToMediaProps = (pimImage: IPimImage | undefined) => {
  return pimImage
    ? {
      item: {
        token: pimImage.token,
        name: pimImage.name ?? pimImage.token,
        width: pimImage.width,
        height: pimImage.height,
      },
    }
    : undefined;
};

export const pimImageToOpenGraphImage = (pimImage: IPimImage): OpenGraphImage => {
  return {
    url: `https://storage.onpage.it/${pimImage.token}/${pimImage.name ?? pimImage.token}`,
    width: pimImage.width,
    height: pimImage.height,
  };
};

export const pimFileToMenuHrefProps = (
  pimFile: IPimFile | null | undefined,
  title?: string
): IMenuHref | undefined => {
  return pimFile
    ? {
      id: 'pim-file',
      type: 'link',
      title: title ?? pimFile.name,
      href: `https://storage.onpage.it/${pimFile.token}/${pimFile.name}`,
      target: '_blank',
    }
    : undefined;
};
